import { Toast } from 'vant'
import $math from './math.js'
import { appointDate } from './index.js'
import i18n from '@/locales/index.js'
export function toastLoading(num = 0) {
  Toast.allowMultiple()
  return Toast.loading({
    duration: num,
    message: i18n.t('loading_with_dot'),
    forbidClick: true,
    loadingType: 'spinner'
  })
}

function filterEmptyAttr(params = {}) {
  const newParam = {}
  Object.keys(params)
    .filter(item => params[item] || params[item] === 0)
    .forEach(key => {
      let value = params[key]
      if (typeof value === 'string') {
        value = value.trim()
      }
      newParam[key] = value
    })
  return newParam
}

/**
 * 格式化输入框，只允许输入小数点以及数字，小数点只允许后两位
 * @param value 输入框的值
 * @private
 */
function _formatInput(value) {
  value = value.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
  value = value.replace(/^\./g, '') // 验证第一个字符是数字而不是字符
  value = value.replace(/\.{2,}/g, '.') // 只保留第一个.清除多余的
  value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
  return value
}

export default {
  toastLoading,
  filterEmptyAttr,
  appointDate,
  $math
}
